import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '..';
import { ErrorCodes } from '../../enums';
import { IPickedResult } from '../../interfaces';

interface IFilePickerProps {
    label: string;
    multiple?: boolean;
    accept?: Array<string>;
    maxSize?: number;
    maxCount?: number;
    disabled?: boolean;
    onPicked: (files: IPickedResult) => void;
}

export class FilePicker extends React.Component<IFilePickerProps> {
    private fileInput = React.createRef<HTMLInputElement>();

    triggerInputFile = () => {
        this.fileInput.current.click();
    };

    validateSelectedFileType = (file: File) => {
        return this.props.accept.indexOf(file.name.split('.').pop().toLowerCase()) < 0;
    };

    validateSelectedFileSize = (file: File) => {
        return file.size > this.props.maxSize;
    };

    validateFile = (file: File) => {
        const errors = [];
        if (this.props.accept && this.validateSelectedFileType(file)) {
            errors.push(ErrorCodes.FILE_TYPES_INVALID);
        }

        if (this.props.maxSize && this.validateSelectedFileSize(file)) {
            errors.push(ErrorCodes.FILE_SIZE_INVALID);
        }
        return errors;
    };

    prepareFileResults = (files: FileList) => {
        return Array.from(files).map((file) => {
            return {
                file,
                errors: this.validateFile(file),
            };
        });
    };

    onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const commonErrors = [];

        if (this.props.maxCount && e.target.files.length > this.props.maxCount) {
            commonErrors.push(ErrorCodes.FILE_COUNT_INVALID);
        }

        this.props.onPicked({
            files: this.prepareFileResults(e.target.files),
            commonErrors: commonErrors,
        });

        this.fileInput.current.value = null;
    };

    generateAcceptableFileTypes = () => {
        if (this.props.accept) {
            return this.props.accept.map((type) => '.' + type).join(',');
        } else {
            return '*';
        }
    };

    public render() {
        return (
            <>
                <label htmlFor={this.props.label} className="hidden">
                    <FormattedMessage id="UPLOAD_FILES" />
                </label>
                <input
                    id={this.props.label}
                    className="d-none"
                    ref={this.fileInput}
                    accept={this.generateAcceptableFileTypes()}
                    multiple={this.props.multiple || false}
                    onChange={this.onChange}
                    type="file"
                />
                <Button
                    type="button"
                    disabled={this.props.disabled}
                    variant="secondary"
                    onClick={this.triggerInputFile}
                >
                    {this.props.label}
                </Button>
            </>
        );
    }
}
